import { getStoreValue } from 'pixel-react';

export const CURRENT_PROJECT_CHANGE_EVENT = 'current-project-change';

export const getActiveProjectId = (): string | null => {
  const currentProject = getStoreValue('current-project') as
    { id?: string } | null | undefined;
  return currentProject?.id ?? null;
};

export const isAllProjectsId = (projectId?: string | null): boolean =>
  !projectId || projectId === 'All Projects';

export const notifyCurrentProjectChange = () => {
  window.dispatchEvent(new Event(CURRENT_PROJECT_CHANGE_EVENT));
};
